var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swap"},[_vm._m(0),_c('div',{staticClass:"swap-table"},[_c('Table',{attrs:{"head":_vm.swapOrderTableHead,"width":"1654","height":"550"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swap-top"},[_c('div',{staticClass:"swap-top__name"},[_vm._v("换货单")])])
}]

export { render, staticRenderFns }